import { createCustomPaginatedQueryOptions } from "../shared/createCustomPaginatedQueryOptions";
import { listQuickReorders } from "@/graphql/queries";
import { QuickReorder } from "@/types/AppTypes";

export const fetchCustomPaginatedQuickReordersQueryOptions = (
  filters: Record<string, any> = {},
  limit = 10,
  options = {}
) =>
  createCustomPaginatedQueryOptions<QuickReorder>({
    queryKey: ["quick_reorders", filters],
    graphqlQuery: listQuickReorders,
    getVariables: (pageParam) => ({
      limit,
      nextToken: pageParam,
      filter: {
        ...filters,
      },
    }),
    options: {
      ...options,
    },
  });
